import React from "react";
import {
  getDivisionDoc,
  getLifterAwardsWeightClassDoc,
} from "util/lifterHelper";
import DisplayComponent from "./DisplayComponent";
import { Lifter, Meet } from "types";
import get from "lodash/get";
import map from "lodash/map";
import size from "lodash/size";
import { useDisplaySettings } from "./DisplaySettingsProvider";
import range from "lodash/range";

const DivisionInfo = ({
  meet,
  currentLifter,
  id,
}: {
  meet: Meet;
  currentLifter: Lifter | undefined | null;
  id: string;
}) => {
  const { maxDivisionsToShow, editMode } = useDisplaySettings();
  return (
    <DisplayComponent style={{ top: 110, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 22,
          width: sizeMultiplier * 600,
        };

        if (editMode) {
          return (
            <div style={style} className="lifter-details">
              {range(maxDivisionsToShow).map((i) => {
                return <div key={i}>Men's Raw Open 120+</div>;
              })}
            </div>
          );
        }

        return (
          <div style={style} className="lifter-details">
            {currentLifter &&
              map(get(currentLifter, "divisions"), (lifterDivision, index) => {
                if (index >= maxDivisionsToShow) {
                  return null;
                }

                const divisionDoc = getDivisionDoc(
                  lifterDivision.divisionId,
                  meet,
                );
                if (!divisionDoc || divisionDoc.hideOnBoard) {
                  return null;
                }
                const divisionName = get(divisionDoc, "name");

                // don't display weight class name if there is only one for this division
                const weightClassDoc = getLifterAwardsWeightClassDoc(
                  meet,
                  currentLifter,
                  lifterDivision,
                );
                const weightClassName =
                  size(divisionDoc.weightClasses) > 1
                    ? get(weightClassDoc, "name")
                    : "";
                return (
                  <div key={`${lifterDivision.divisionId}${index}`}>
                    {divisionName} {weightClassName}
                  </div>
                );
              })}
            {!currentLifter && <div>Men's Raw Open 120+</div>}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default DivisionInfo;
